@if (hasFlow === false) {
  <app-st-icon
               class="cursor-pointer service-flow-warning-icon"
               [filled]="true"
               [bold]="true"
               [color]="'#CB2A2F'"
               [name]="'error'"
               nz-tooltip
               [nzTooltipTitle]="tooltip"></app-st-icon>
}
